import React from 'react';
import styled from 'styled-components';

import useMultiLanguageTranslation from 'hooks/useMultiLanguageTranslation';

import { TOrbit } from '../../i18n/TModules';
import { responseTone } from '../../support/response/responseScale';

const ERROR = responseTone('error');

// 6566:9657: the body first, then the pill, 10.25 apart, inside the turn's own bubble.
const Body = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  > * + * {
    margin-top: 10.25px;
  }
`;

const Text = styled.p`
  margin: 0;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
`;

// 6566:9659: 25 tall, padding 4 / 9, fully rounded, red at 14 % under a 1 px red rule.
const Pill = styled.span`
  padding: 4px 9px;
  border: 1px solid ${ERROR.ink};
  border-radius: 999px;
  background: ${ERROR.fill};
  color: ${ERROR.ink};
  font-size: 10px;
  font-weight: 700;
  line-height: 15px;
`;

const L4OutOfScope: React.FC<{ text: string }> = ({ text }) => {
  const { t } = useMultiLanguageTranslation();

  return (
    <Body data-testid="orbit-l4-out-of-scope">
      <Text data-testid="orbit-l4-text">{text}</Text>
      <Pill>{t(`${TOrbit}.layer4.outOfScope`)}</Pill>
    </Body>
  );
};

export default L4OutOfScope;
